module.exports = {
  title: "BrightBytes.dev",
  siteUrl: "https://brightbytes.dev",
  description:
    "Practical notes on embedded Linux, electronics, and building software. Tutorials and projects by Ahmad Roshanfar.",
  gaMeasurementId: "G-F8YJQXQ4L5",
  author: "Ahmad Roshanfar",
  // Your public creator page on Buy Me a Coffee, Ko-fi, or another service.
  // Leave empty to hide support links until the account is ready.
  supportUrl: "https://ko-fi.com/brightbytesdev",
  supportLabel: "Buy me a coffee",
};
